import React, { useEffect, useRef, useState } from "react";
// import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import "./BybStartup.css"
// import toolkit from "../../assets/images/toolkit.jpeg"
function BybStartup() {

  
  const [isVisible, setIsVisible] = useState(false);

  const textRef = useRef(null);

  // Intersection Observer for fade-in text
  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        setIsVisible(entry.isIntersecting); // Set visibility based on intersection
      },
      {
        threshold: 0.5, // Trigger when 50% of the element is visible
      }
    );

    const textElement = textRef.current;
    if (textElement) observer.observe(textElement);

    return () => {
      if (textElement) observer.unobserve(textElement);
    };
  }, []);


  // StartUp Modal
  const [modalShow, setModalShow] = React.useState(false);

  // BusinessModal
  const [businessModal, setBusinessModal] = React.useState(false);
  
  // MarketingModal
  const [marketingModal, setMarketingModal] = React.useState(false);

   // EntrepreneurModal
   const [entrepreneurModal, setEntrepreneurModal] = React.useState(false);
   
   // CorporateModal
   const [corporateModal, setCorporateModal] = React.useState(false);
  
  function StartUp(props) {
    return (
      <Modal
        {...props}
        size="lg"
        backdrop="static"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        className="start_up brandself_modal"
      >
         <Modal.Header closeButton className="border-0">
        <Modal.Title id="contained-modal-title-vcenter">
        Startups
        </Modal.Title>
      </Modal.Header>
        <Modal.Body>
          <p>
          Define your unique space in the market by identifying your strengths, messaging clarity, and visual consistency. 
          </p>
          <p>
          Launch with a strategic foundation to create lasting impressions and attract your ideal audience​.
          </p>
        </Modal.Body>
      
      </Modal>
    );
  }

  function SmallBusiness(props) {
    return (
      <Modal
        {...props}
        size="lg"
        backdrop="static"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        className="start_up"
      >
         <Modal.Header closeButton className="border-0">
        <Modal.Title id="contained-modal-title-vcenter">
        MSMEs
        </Modal.Title>
      </Modal.Header>
        <Modal.Body>
          <p>
          Address gaps in positioning and customer engagement, ensuring every interaction builds trust. 
          </p>
          <p>
          Face the disruptions and ride the market wave with customer loyalty and differentiate yourself in a competitive market​
          </p>
        </Modal.Body>
      
      </Modal>
    );
  }
  
  function MarketingExecutive(props) {
    return (
      <Modal
        {...props}
        size="lg"
        backdrop="static"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        className="start_up"
      >
         <Modal.Header closeButton className="border-0">
        <Modal.Title id="contained-modal-title-vcenter">
        Marketing Executives
        </Modal.Title>
      </Modal.Header>
        <Modal.Body>
          <p>
          Ensure brand consistency across campaigns by auditing identity, messaging, and audience engagement strategies.  
          </p>
          <p>
          Gain actionable insights to optimise campaign performance and maximise return on investment​​.
          </p>
        </Modal.Body>
      
      </Modal>
    );
  }
 
  function Entrepreneur(props) {
    return (
      <Modal
        {...props}
        size="lg"
        backdrop="static"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        className="start_up"
      >
         <Modal.Header closeButton className="border-0">
        <Modal.Title id="contained-modal-title-vcenter">
        Entrepreneurs
        </Modal.Title>
      </Modal.Header>
        <Modal.Body>
          <p>
          Refine your personal brand by clarifying your unique value proposition and aligning it with audience expectations.​  
          </p>
          <p>
          Use the kit to craft consistent messaging and visuals that position you as a leader in your niche​.​
          </p>
        </Modal.Body>
       


      </Modal>
    );
  }

  function Corporate(props) {
    return (
      <Modal
        {...props}
        size="lg"
        backdrop="static"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        className="start_up"
      >
         <Modal.Header closeButton className="border-0">
        <Modal.Title id="contained-modal-title-vcenter">
        Brand Managers​
        </Modal.Title>
      </Modal.Header>
        <Modal.Body>
          <p>
          Maintain brand cohesion across teams and channels by assessing consistency in visuals, messaging, and touchpoints.
          </p>
          <p>
          Use the audit to adapt to evolving market trends, ensuring your brand remains aligned and competitive​.
          </p>
        </Modal.Body>
       


      </Modal>
    );
  }

  return (
   <>
  <section className='byb-startup'>
    <div className='container'>
      <div className='byb-startup-header'>
      <h1 ref={textRef}
                    className={`fade-in-text ${isVisible ? "visible" : ""}`}>From Startup to Success: A Toolkit for Every Business Stage</h1>
 

      </div>

{/* ///////////////////////////////////////////////////////// */}



<div class="card-slider">
  <div class="res-card">
 
  <div className="res-card-content">
                <img src="https://brewyourbrand.blr1.cdn.digitaloceanspaces.com/arrow.svg" alt="" /> 
                <h6>Startups</h6>
                {/* <p>Kickstart Your Brand With A Solid Foundation.</p> */}
                <div className='res-plus-icon'>
                  <i className="fa-solid fa-circle-plus" onClick={() => setModalShow(true)}></i>
                </div>
              </div>
  </div>

  <div class="res-card">
      <div className="res-card-content">
                <img src="https://brewyourbrand.blr1.cdn.digitaloceanspaces.com/arrow.svg" alt="" /> 
                <h6>Small Business Owners</h6>
                {/* <p>Kickstart Your Brand With A Solid Foundation.</p> */}
                <div className='res-plus-icon'>
                  <i className="fa-solid fa-circle-plus" onClick={() => setBusinessModal(true)}></i>
                </div>
              </div>
  </div>

  <div class="res-card">
  <div className="res-card-content">
                <img src="https://brewyourbrand.blr1.cdn.digitaloceanspaces.com/arrow.svg" alt="" /> 
                <h6>Marketing Executives</h6>
                {/* <p>Kickstart Your Brand With A Solid Foundation.</p> */}
                <div className='res-plus-icon'>
                  <i className="fa-solid fa-circle-plus" onClick={() => setMarketingModal(true)}></i>
                </div>
              </div>
  </div>

  <div class="res-card">
        <div className="res-card-content">
                  <img src="https://brewyourbrand.blr1.cdn.digitaloceanspaces.com/arrow.svg" alt="" /> 
                  <h6>Entrepreneurs</h6>
                  {/* <p>Kickstart Your Brand With A Solid Foundation.</p> */}
                  <div className='res-plus-icon'>
                    <i className="fa-solid fa-circle-plus" onClick={() => setEntrepreneurModal(true)}></i>
                  </div>
                </div>
    </div>

    <div class="res-card">
        <div className="res-card-content">
                  <img src="https://brewyourbrand.blr1.cdn.digitaloceanspaces.com/arrow.svg" alt="" /> 
                  <h6>Brand Managers</h6>
                  {/* <p>Kickstart Your Brand With A Solid Foundation.</p> */}
                  <div className='res-plus-icon'>
                    <i className="fa-solid fa-circle-plus" onClick={()=>setCorporateModal(true)}></i>
                  </div>
                </div>
    </div>

</div>




    </div>




<div className="container">
  <div className="row">
    <div className="col-lg-12">
      <div className="cards ">

    
                  <div className="byb-slider-card ">
                      <div className="card-content">
                          <img src="https://brewyourbrand.blr1.cdn.digitaloceanspaces.com/arrow.svg" alt="" /> 
                          <h6>Startups</h6>
                          <div className='byb-plus-icon'>
                            <i className="fa-solid fa-circle-plus" onClick={() => setModalShow(true)}></i>
                          </div>
                      </div>
                    </div>

                    <div className="byb-slider-card ">
                      <div className="card-content">
                        <img src="https://brewyourbrand.blr1.cdn.digitaloceanspaces.com/arrow.svg" alt="" /> 
                        <h6>MSMEs</h6>
                        {/* <p>Scale Your Brand With Strategy And Precision.</p> */}
                        <div className='byb-plus-icon'>
                          <i className="fa-solid fa-circle-plus" onClick={() => setBusinessModal(true)}></i>
                        </div>
                      </div>
                    </div>

                    <div className="byb-slider-card ">
                      <div className="card-content">
                        <img src="https://brewyourbrand.blr1.cdn.digitaloceanspaces.com/arrow.svg" alt="" /> 
                        <h6>Marketing Executives</h6>
                        {/* <p>Refresh And Renew Your Brand For Continued Success.</p> */}
                        <div className='byb-plus-icon'>
                          <i className="fa-solid fa-circle-plus" onClick={() => setMarketingModal(true)}></i>
                        </div>
                      </div>
                   </div>

                   <div className="byb-slider-card ">
                      <div className="card-content">
                            <img src="https://brewyourbrand.blr1.cdn.digitaloceanspaces.com/arrow.svg" alt="" /> 
                            <h6>Entrepreneurs</h6>
                            <div className='byb-plus-icon'>
                              <i className="fa-solid fa-circle-plus" onClick={() => setEntrepreneurModal(true)}></i>
                            </div>
                      </div>
                    </div>

                  <div className="byb-slider-card ">
                    <div className="card-content">
                      <img src="https://brewyourbrand.blr1.cdn.digitaloceanspaces.com/arrow.svg" alt="" /> 
                      <h6>Brand Managers</h6>
                      {/* <p>Turn Your Vision Into A Powerful Brand.</p> */}
                      <div className='byb-plus-icon'>
                        <i className="fa-solid fa-circle-plus" onClick={()=>setCorporateModal(true)}></i>
                      </div>
                    </div>
                  </div>
    </div>
  </div>
  </div>       

</div>

  
{/*             
    <div className="byb-ezd-slider">
      <div className="byb-slider-wrapper">
        <div className="byb-slider-overflow">
          <div className="byb-slider-scroll swiper-wrapper">
            <div className="byb-slider-card swiper-slide">
              <div className="card-content">
                <img src="https://brewyourbrand.blr1.cdn.digitaloceanspaces.com/arrow.svg" alt="" /> 
                <h6>Startups</h6>
                <div className='byb-plus-icon'>
                  <i className="fa-solid fa-circle-plus" onClick={() => setModalShow(true)}></i>
                </div>
              </div>
            </div>

            <div className="byb-slider-card swiper-slide">
              <div className="card-content">
                <img src="https://brewyourbrand.blr1.cdn.digitaloceanspaces.com/arrow.svg" alt="" /> 
                <h6>MSME</h6>
                <div className='byb-plus-icon'>
                  <i className="fa-solid fa-circle-plus" onClick={() => setBusinessModal(true)}></i>
                </div>
              </div>
            </div>

            <div className="byb-slider-card swiper-slide">
              <div className="card-content">
                <img src="https://brewyourbrand.blr1.cdn.digitaloceanspaces.com/arrow.svg" alt="" /> 
                <h6>Marketing Executives</h6>
                <div className='byb-plus-icon'>
                  <i className="fa-solid fa-circle-plus" onClick={() => setMarketingModal(true)}></i>
                </div>
              </div>
            </div>

            <div className="byb-slider-card swiper-slide">
              <div className="card-content">
                <img src="https://brewyourbrand.blr1.cdn.digitaloceanspaces.com/arrow.svg" alt="" /> 
                <h6>Entrepreneurs</h6>
                <div className='byb-plus-icon'>
                  <i className="fa-solid fa-circle-plus" onClick={() => setEntrepreneurModal(true)}></i>
                </div>
              </div>
            </div>

            <div className="byb-slider-card swiper-slide">
              <div className="card-content">
                <img src="https://brewyourbrand.blr1.cdn.digitaloceanspaces.com/arrow.svg" alt="" /> 
                <h6>Brand Managers</h6>
                <div className='byb-plus-icon'>
                  <i className="fa-solid fa-circle-plus" onClick={()=>setCorporateModal(true)}></i>
                </div>
              </div>
            </div>

            <div className="byb-slider-card swiper-slide">
              <div className="card-content">
                <img src="https://brewyourbrand.blr1.cdn.digitaloceanspaces.com/arrow.svg" alt="" /> 
                <h6>Entrepreneurs</h6>
                <p>Turn Your Vision Into A Powerful Brand.</p>
                <div className='byb-plus-icon'>
                  <i className="fa-solid fa-circle-plus"></i>
                </div>
              </div>
            </div>

            <div className="byb-slider-card swiper-slide">
              <div className="card-content">
                <img src="https://brewyourbrand.blr1.cdn.digitaloceanspaces.com/arrow.svg" alt="" /> 
                <h6>Entrepreneurs</h6>
                <p>Turn Your Vision Into A Powerful Brand.</p>
                <div className='byb-plus-icon'>
                  <i className="fa-solid fa-circle-plus"></i>
                </div>
              </div>
            </div>

        
          </div>

          <div className="byb-swiper-button-next">
          <i className="fa-solid fa-chevron-right"></i>
          </div>
          <div className="byb-swiper-button-prev">
          <i className="fa-solid fa-chevron-left"></i>
          </div>
        </div>
      </div>
    </div> */}




  </section>
   

  <StartUp
        show={modalShow}
        onHide={() => setModalShow(false)}
      />


        <SmallBusiness
        show={businessModal}
        onHide={() => setBusinessModal(false)}
      />
        <MarketingExecutive
        show={marketingModal}
        onHide={() => setMarketingModal(false)}
      />
        <Entrepreneur
        show={entrepreneurModal}
        onHide={() => setEntrepreneurModal(false)}
      />

<Corporate
        show={corporateModal}
        onHide={() => setCorporateModal(false)}
      />







   </>
  )
}

export default BybStartup